import { CrudFilter, CrudSorting, LogicalFilter } from 'app/context/data/types';

export const transformSorterAndFilters = (
  filters: CrudFilter[],
  sorters: CrudSorting
) => {
  let transformedSorters = {};
  if (Array.isArray(sorters) && sorters.length > 0) {
    const sortBy = sorters[0].field;
    const order = sorters[0].order;
    transformedSorters = {
      orderBy: `${sortBy}:${order}`
    };
  }

  const transformedFilters = (filters && Array.isArray(filters))
    ? filters.reduce((acc: Record<string, any>, filter) => {
      // Handle date range filters (between operator)
      if (
        filter.operator === 'between' &&
        Array.isArray(filter.value) &&
        filter.value.length === 2
      ) {
        const [start, end] = filter.value;
        acc[`${filter.field}From`] = start;
        acc[`${filter.field}To`] = end;
        return acc;
      }

      // Handle simple filters, excluding logical operators
      if (filter.operator !== 'and' && filter.operator !== 'or') {
        if ('field' in filter && 'value' in filter) {
          acc[filter.field] = filter.value;
        }
      }
      return acc;
    }, {} as Record<string, any>)
    : {};

  return {
    filters: transformedFilters,
    sorters: transformedSorters
  };
};
